import { observable, action, computed, makeObservable } from 'mobx';
import { Pages } from '~/lib/ApiModel';
import { LoadingTracker } from '~/lib/store/LoadingTracker';
import { PagedItem, PageSpec } from '../helper/PagingHelper';

type PageLoaderFunction<T> = (pageSpec: PageSpec) => Promise<PagedItem<T>>;

export class PagedItemStore<T> {
    getPage: PageLoaderFunction<T>;

    constructor(loader: PageLoaderFunction<T>) {
        makeObservable(this);
        this.getPage = loader;
    }

    @observable
    loadingTracker: LoadingTracker = new LoadingTracker();

    @observable
    pageItems: T[] = [];

    @observable
    totalItems = 0;

    @observable
    currentPageSpec: PageSpec = undefined;

    @observable
    pageLinks?: Pages = undefined;

    @computed
    get status() {
        return this.loadingTracker.status;
    }

    get lastError() {
        return this.loadingTracker.lastError;
    }

    @action
    setPage(link: PageSpec, paged: PagedItem<T>) {
        this.pageItems = paged.items;
        this.totalItems = paged.total;
        this.pageLinks = paged.pageLinks;
        this.currentPageSpec = link;
    }

    refresh() {
        void this.load(this.currentPageSpec);
    }

    async load(pageSpec: PageSpec) {
        return this.loadingTracker.track(async (isCurrent) => {
            const res = await this.getPage(pageSpec);
            if (isCurrent()) this.setPage(pageSpec, res);
        });
    }
}
